import CloseIcon from '@mui/icons-material/Close';
import {
    Button
} from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ShoppingCartWithItems } from 'common-models';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { VisitorState } from '../../features/visitor/visitorSlice';
import { MiniCartItem } from './MiniCartItem';

type MiniCartContentProps = {
    cartWithItems: ShoppingCartWithItems,
    visitor: VisitorState;
    setDrawerOpen: (state: boolean) => void;
}

const MiniCartContent: FC<MiniCartContentProps> = ({ cartWithItems, visitor, setDrawerOpen }) => {
    return (
        <Grid
            className='minicart'
            container>
            <Grid
                container
                className='minicart'
            >
                <Grid
                    size="auto"
                    className='minicart-title-frame'>
                    <Typography variant={'h4'}>Varukorg</Typography>
                    <Button
                        variant='text'
                        onClick={() => setDrawerOpen(false)}
                    >
                        <CloseIcon />
                    </Button>
                </Grid>
            </Grid>
            <Grid
                container
                alignContent='center'
                className='minicart-footer'>
                {
                    cartWithItems?.items
                        ? <>
                            <Grid container>
                                Alla priser är i SEK inklusive moms.
                            </Grid>
                            <Grid
                                size={{ sm: 12 }}
                                className='minicart-total-specification'>
                                Total: {cartWithItems.totalSum * 1.25}
                            </Grid>
                            <Grid
                                size={{ sm: 12 }}>
                                <Link
                                    to={'checkout'}
                                    onClick={() => setDrawerOpen(false)} >
                                    Gå till betalning
                                </Link>
                            </Grid>
                            {cartWithItems?.items.map(x => <MiniCartItem key={`mci-${x.id}`} cartItem={x} visitor={visitor} />)}
                        </>
                        : <p>(Här är det tomt)</p>
                }
            </Grid >
        </Grid>


    )
}

export default MiniCartContent
